export const DepartmentInitialValues = {
  department: "",
};
